//  IMPORTANT:
//  This file is generated. Your changes will be lost.
//  Source Table: [dbo].[GeographyRole]

import { LookupTableEntry } from "src/app/shared/models/lookup-table-entry";
import { SelectDropdownOption } from "src/app/shared/components/forms/form-field/form-field.component"

export enum GeographyRoleEnum {
  WaterManager = 1,
  Normal = 2,
  HelpDeskManager = 3
}

export const GeographyRoles: LookupTableEntry[]  = [
  { Name: "WaterManager", DisplayName: "Water Manager", Value: 1, SortOrder: 10 },
  { Name: "Normal", DisplayName: "Normal", Value: 2, SortOrder: 20 },
  { Name: "HelpDeskManager", DisplayName: "Help Desk Manager", Value: 3, SortOrder: 30 }
];
export const GeographyRolesAsSelectDropdownOptions = GeographyRoles.map((x) => ({ Value: x.Value, Label: x.DisplayName, SortOrder: x.SortOrder } as SelectDropdownOption));
